import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { HeadedComponent } from './headed/headed.component';
import { TopbarComponent } from './topbar/topbar.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { DisclaimerModule } from '../disclaimer/disclaimer.module';
import { TranslationModule } from '../shared/translation/translation.module';

@NgModule({
  declarations: [
    NavMenuComponent,
    TopbarComponent,
    HeadedComponent
  ],
  imports: [
    CommonModule,
    DisclaimerModule,
    RouterModule,
    DropDownsModule,
    TranslationModule
  ],
  exports: [
    NavMenuComponent,
    TopbarComponent,
    HeadedComponent
  ]
})
export class NavigationModule { }
